import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../environments/environment';
import { UserService } from '../auth/user.service';

@Injectable({
  providedIn: 'root'
})
export class PropertyImageService {
    constructor(
        private readonly httpClient: HttpClient,
        private readonly userService: UserService
    ) {
    }

    getPropertyImages(uuid: string): Promise<any> {
        return firstValueFrom(this.httpClient.get(`${environment.api_server_url}/api/property-images/${uuid}`)).then((res) => {
            return res;
        });
    }

    getPropertyMainImage(uuid: string): Promise<any> {
        return firstValueFrom(this.httpClient.get(`${environment.api_server_url}/api/property-main-image/${uuid}`)).then((res) => {
            return res;
        });
    }

    uploadPropertyImage(property_id: string, name: string, image: any): Promise<any> {
        const headers = new HttpHeaders().set('x-access-token', this.userService.user.token);
        return firstValueFrom(this.httpClient.post(`${environment.api_server_url}/api/property-image`, {property_id, name, image}, {headers})).then((res) => {
            return res;
        });
    }

    deletePropertyImage(id: number): Promise<any> {
        const headers = new HttpHeaders().set('x-access-token', this.userService.user.token);
        return firstValueFrom(this.httpClient.delete(`${environment.api_server_url}/api/property-image/${id}`, {headers})).then((res) => {
            return res;
        });
    }

    setAsMainImage(id: number, property_id: number): Promise<any> {
        const headers = new HttpHeaders().set('x-access-token', this.userService.user.token);
        return firstValueFrom(this.httpClient.put(`${environment.api_server_url}/api/property-image-set-main`, {property_id: property_id, id: id}, {headers})).then((res) => {
            return res;
        });
    }


}
